import { render } from "./accordion-item.vue?vue&type=template&id=23c58ada&scoped=true"
import script from "./accordion-item.vue?vue&type=script&lang=js"
export * from "./accordion-item.vue?vue&type=script&lang=js"

import "./accordion-item.vue?vue&type=style&index=0&id=23c58ada&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c58ada"]])

export default __exports__